import { BlobCard } from "@/components/BlobCard";

export const ExpertiseCard = (props) => {
  return <BlobCard {...props} />;
};

ExpertiseCard.defaultProps = BlobCard.defaultProps;
ExpertiseCard.propTypes = BlobCard.propTypes;
